import React from "react";

import { splitHighlightedFragments } from "./searchUtils";

interface Props {
  value: string | null | undefined;
  className?: string;
}

const SearchHighlightedText: React.FC<Props> = ({ value, className = "" }) => {
  const fragments = splitHighlightedFragments(value);

  if (fragments.length === 0) {
    return <span className={className}>{value || ""}</span>;
  }

  return (
    <span className={className}>
      {fragments.map((fragment, index) =>
        fragment.highlighted ? (
          <mark
            key={`${fragment.text}-${index}`}
            className="rounded bg-eoe-icon px-0.5 text-eoe-text-heading dark:bg-eoe-dark-icon dark:text-eoe-dark-text-heading"
          >
            {fragment.text}
          </mark>
        ) : (
          <span key={`${fragment.text}-${index}`}>{fragment.text}</span>
        )
      )}
    </span>
  );
};

export default SearchHighlightedText;
